
import React, { useState, useMemo } from 'react';
import { ActivityType, Activity } from '../../types';
import DashboardNav from './DashboardNav';
import ActivityView from './ActivityView';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import { ClearAll, Close, ExitToApp } from '@mui/icons-material';

import { UserRole } from '../../types';
import { Hammer, SledgeHammer } from '../uitools/Icons';

type Props = { role:UserRole, logout: ()=>boolean , token:any}

const LateralDashboard: React.FC<Props> = ({token,role,logout}) => {
  const [selectedActivity, setSelectedActivity] = useState<ActivityType | undefined>(undefined);
  const [isSidebarVisible, setIsSidebarVisible] = useState<boolean>(true);


  const guestactivities: Activity[] = useMemo(() => [
    {
      value: 2,
      id: ActivityType.Ritiro,
      label: 'Visualizza attrezzi e restituisci',
      icon: AddCircleOutlineIcon,
      description: "Questa sezione è dedicata alla visualizzazione dei dati presenti nel database. Puoi accedere a questa sezione senza alcuna autorizzazione specifica."
    },
    { 
      value: 4,
      id: ActivityType.Logout, 
      label: 'Logout', 
      icon: ExitToApp,
      description: "Disconnessione."
    },
  ],[]);
  
  const activities: Activity[] = useMemo(() => [
    { 
      value: 0,
      id: ActivityType.Immissione, 
      label: 'Carica attrezzi', 
      icon: AddCircleOutlineIcon,
      description: "Questa sezione è dedicata all'inserimento di nuovi dati nel sistema. Compila i moduli richiesti per registrare nuove informazioni." 
    },
    { 
      value: 1,
      id: ActivityType.Assegnazione, 
      label: 'Attrezzi', 
      icon: SledgeHammer,
      description: "Gestisci l'assegnazione di compiti e responsabilità. Visualizza i compiti pendenti e assegnali ai membri del team appropriati."
    },
    { 
      value: 2,
      id: ActivityType.Ritiro, 
      label: 'Visualizza e restituisci', 
      icon: FileDownloadIcon,
      description: "Traccia il ritiro di materiali o risorse. Registra le uscite e mantieni aggiornato l'inventario."
    },
    { 
      value: 3,
      id: ActivityType.GestioneUtenti, 
      label: 'Gestione utenti, magazzini e classi di utensili', 
      icon: AccessibilityIcon,
      description: "Amministra gli utenti del sistema. Aggiungi nuovi utenti, modifica i permessi e gestisci i profili esistenti."
    },
    { 
      value: 4,
      id: ActivityType.Logout, 
      label: 'Logout', 
      icon: ExitToApp,
      description: "Disconnessione."
    },
  ], []);

  const handleSelectActivity = (activityType: ActivityType) => {
    setSelectedActivity(activityType);
    toggleSidebar();
  };

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const currentActivityDetails = useMemo(() => {
    if(role!==UserRole.Administrator)
      return guestactivities.find(act => act.id === selectedActivity);
    return activities.find(act => act.id === selectedActivity);
  }, [selectedActivity, activities, role, guestactivities]);

  return (
    <div className="flex h-screen bg-slate-100 font-sans">
      {isSidebarVisible && (
        <DashboardNav 
          activities={role===UserRole.User?guestactivities:activities}
          selectedActivity={selectedActivity!} 
          onSelectActivity={handleSelectActivity} 
        />
      )}
      <main className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white shadow-md p-4 flex items-center space-x-3">
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-md text-slate-600 hover:bg-slate-200 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 transition-colors"
            aria-label={isSidebarVisible ? "Nascondi barra laterale" : "Mostra barra laterale"}
          >
            {isSidebarVisible ? <Close className="h-6 w-6" /> : <ClearAll className="h-6 w-6" />}
          </button>
          <h1 className="text-xl font-semibold text-slate-700">Dashboard Principale</h1>
        </header>
        {!isSidebarVisible && <ActivityView token={token} role={role} activity={currentActivityDetails} logout={logout}/>}
      </main>
    </div>
  );
};

export default LateralDashboard;